<template>
  <div class="finding-tenant-page">
    <v-img alt="Logo" class="shrink mr-2 app tenant-logo" contain :src="logoimage" transition="scale-transition" />

    <v-sheet class="folded-corner tenant-panel">
      <v-container>
        <v-card elevation="0" class="tenant-card align-center pa-4 mx-auto">
          <header class="tenant-header">
            <h1>{{ "รายชื่อบริษัท" }}</h1>
            <p>{{ "LIST OF COMPANY NAMES" }}</p>
            <v-divider class="tenant-divider"></v-divider>
          </header>

          <section class="tenant-search-area">
            <div class="selected-tenant" :class="{ empty: ShowData == '' }">
              {{ ShowData || "เลือกบริษัทที่ต้องการติดต่อ" }}
            </div>

            <v-text-field
              outlined
              hide-details
              v-model="SearchTenant"
              ref="inputTenant"
              class="tenant-search-input"
              placeholder="Search company name"
            ></v-text-field>

            <v-virtual-scroll
              v-if="SearchTenant != ''"
              v-model="selectedItem"
              class="tenant-result-list"
              :items="TenantList"
              height="150"
              item-height="50"
            >
              <template v-slot:default="{ item }">
                <v-list-item :key="item.tenantID || item.nameEng" class="tenant-result-item" @click="dataTenant(item)">
                  <v-list-item-content>
                    <v-list-item-title class="tenant-result-row">
                      <strong class="tenant-name-eng">{{ item.nameEng }}</strong>
                      <strong class="tenant-name-th">{{ item.nameThai == '-' ? '' : item.nameThai }}</strong>
                      <span class="tenant-floor">{{ $t("message.Floor") }}: <strong>{{ item.floorID }}</strong></span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-virtual-scroll>
            <div v-else class="tenant-result-list tenant-result-placeholder">
              พิมพ์ชื่อบริษัทเพื่อค้นหา
            </div>
          </section>

          <section class="tenant-keyboard-panel">
            <MultiSimpleKeyboardTenant @onChange="onChangeTenant" />
          </section>

          <div class="tenant-actions">
            <v-btn color="#344054" class="box white--text text-capitalize tenant-action-btn" router
              @click="BackToIdentifySelection()">
              {{ $t("message.Back") }}
            </v-btn>
            <v-btn color="#344054" class="box white--text text-capitalize tenant-action-btn" router
              :disabled="ShowData == ''" @click="printQr()">
              {{ $t("message.Continue") }}
            </v-btn>
          </div>
        </v-card>
      </v-container>
    </v-sheet>


    <v-dialog v-model="LoadingDialog" persistent width="300">
      <v-card color="#1D2939" dark>
        <v-card-text class="white--text">
          <v-row>
            <p style="text-align: center">Loading</p>
          </v-row>
          <v-row>
            <v-progress-linear indeterminate color="#ffffff" class="mb-0"></v-progress-linear>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import MultiSimpleKeyboardTenant from "@/components/MultiSimpleKeyboard";
// import logoimage from "@/assets/OneBangkokLogo.png";
// import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "FindingTenant",
  components: {
    MultiSimpleKeyboardTenant,
    // ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      LoadingDialog: false,
      selectedItem: null,

      inputTenantName: "",
      TenantName: "",
      Textkeyboard: "",
      SearchTenant: "",
      ShowData: "",
      ShowDataTh: "",
      TenantList: [],
      TenantListName: [],
      data: [],
      zoneName: "",
      tenantName: "",
      floorID: "",
      lang: "en",
      logoimage: "",
    };
  },

  mounted: function () {
    let self = this;
    console.log(self.$route.params.data);
    self.data = self.$route.params.data;
    self.lang = localStorage.getItem("lang");
    self.logoimage = require("@/assets/OneBangkokLogo.png");

    self.$refs.inputTenant.focus();
    // this.SearchDataTenant();
  },

  watch: {
    // SearchTenant: function (value) {
    //     let self = this;
    //     if(value.length > 3){
    //         self.SearchDataTenant(value);
    //     }
    // }

    '$i18n.locale'(newLocale, oldLocale) {
      console.log(`เปลี่ยนภาษา: ${oldLocale} → ${newLocale}`);
    }

  },

  methods: {
    dataTenant(item) {
      // let data = input.replace("undefined", "");
      // this.SearchTenant = data;
      let self = this;
      let textTh = item.nameThai == "-" ? "" : item.nameThai;


      let text = item.nameEng  + '  ' + textTh + '  ' + 'F. ' + item.floorID;

      



      self.zoneName = item.zoneName;
      self.tenantName = item.tenantName;


      if (self.data != null) {
        if (self.data.documentNumber != undefined && self.data.documentNumber != "") {
          self.data.zoneID = item.zoneID;
          self.data.floorID = item.floorID;
          self.data.locationID = item.locationID;
          self.data.tenantID = item.tenantID;
          self.data.referenceQr = localStorage.getItem("LogId");
          self.data.ip = localStorage.getItem("IP");
        }
      }
      this.ShowData = text;
      this.ShowDataTh = textTh;
    },
    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },

    select() {
      this.$refs.inputTenant.select();
    },

    onChangeTenant(input) {
      let self = this;
      self.SearchTenant = input;
      self.SearchDataTenant();
    },

    BackToIdentifySelection() {
      let self = this;
      self.$router.push("/MainMenu");
      // self.$router.push("/CapturePerson");
    },
    printQr() {
      let self = this;
      // self.$router.push("/PrintQr");
      self.$router.push({
        name: "PrintQr",
        path: "/PrintQr",
        params: {
          data: self.data,
          zoneName: self.zoneName,
          tenantName: self.tenantName,
        },
      });
    },

    CapturePerson() {
      let self = this;
      self.$router.push("/CapturePerson");
    },

    // SearchDataTenant(value) {
    //   let self = this;
    //   let temp = {
    //     search: value,
    //   };
    //   axios
    //     .post(`${self.url}Main/searchDataTenant`, temp)
    //     .then(function(response) {
    //       if (response.data.status == 0) {
    //         self.TenantList = response.data.data;
    //         console.log(response.data.data);
    //       }
    //     })
    //     .catch(function(error) {
    //       self.MessageAlert = error;
    //     });
    // },

    SearchDataTenant() {
      let self = this;
      let temp = {
        search: self.SearchTenant,
        lang: 'en',
      };
      axios
        .post(`${self.url}VMS/searchDataTenant`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.TenantList = response.data.data;
            // console.log(self.TenantList);
          }
          if (response.data.status == 1) {
            self.TenantList = [];
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
        });
    },
  },
};
</script>
<style scoped>
.finding-tenant-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(12px, 1.7vh, 22px);
  padding: clamp(16px, 2.6vw, 36px);
}

.finding-tenant-page .tenant-logo {
  width: min(28vw, 430px) !important;
  max-width: min(28vw, 430px) !important;
  margin: 0 !important;
}

.finding-tenant-page .tenant-panel {
  width: min(1160px, calc(100vw - 150px)) !important;
  min-height: 0 !important;
  max-height: calc(100vh - 150px);
  margin: 0 auto !important;
  padding: clamp(16px, 2vw, 30px) !important;
}

.tenant-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: clamp(10px, 1.3vh, 18px);
}

.tenant-header {
  text-align: center;
}

.tenant-header h1 {
  color: #344054;
  font-size: clamp(34px, 3.1vw, 56px);
  font-weight: 900;
  line-height: 1.05;
  margin: 0;
}

.tenant-header p {
  color: #667085;
  font-size: clamp(20px, 1.8vw, 32px);
  font-weight: 800;
  line-height: 1.2;
  margin: 8px 0 0;
}

.tenant-divider {
  width: min(520px, 44vw);
  margin: 12px auto 0;
  border-top-width: 7px !important;
  border-color: #344054 !important;
}

.tenant-search-area {
  width: min(920px, 100%);
  margin: 0 auto;
}

.selected-tenant {
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #344054;
  font-size: clamp(16px, 1.15vw, 22px);
  font-weight: 900;
  text-align: center;
  margin-bottom: 8px;
}

.selected-tenant.empty {
  color: #98a2b3;
  font-weight: 700;
}

.tenant-search-input {
  margin-bottom: 10px;
}

.tenant-search-input ::v-deep input {
  color: #111827;
  font-size: clamp(26px, 2.2vw, 38px) !important;
  font-weight: 800;
  text-align: center;
}

.tenant-search-input ::v-deep .v-input__slot {
  min-height: 64px !important;
  border-radius: 12px !important;
  background: rgba(255, 255, 255, 0.92) !important;
  box-shadow:
    inset 0 2px 6px rgba(16, 24, 40, 0.08),
    0 10px 18px rgba(16, 24, 40, 0.08);
}

.tenant-result-list {
  height: min(15vh, 150px) !important;
  border: 1px solid rgba(52, 64, 84, 0.18);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.82);
  overflow: hidden;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.tenant-result-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #98a2b3;
  font-size: clamp(18px, 1.4vw, 24px);
  font-weight: 800;
}

.tenant-result-item {
  min-height: 50px !important;
  border-bottom: 1px solid rgba(52, 64, 84, 0.08);
}

.tenant-result-item:hover {
  background: rgba(52, 64, 84, 0.08);
}

.tenant-result-row {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  color: #111827;
  font-size: clamp(15px, 1.05vw, 19px);
}

.tenant-name-eng,
.tenant-name-th {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tenant-floor {
  color: #344054;
  font-weight: 800;
  white-space: nowrap;
}

.tenant-keyboard-panel {
  width: min(960px, 100%);
  margin: 0 auto;
  padding: 10px;
  border-radius: 16px;
  background: rgba(248, 250, 252, 0.92);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.88),
    0 14px 28px rgba(16, 24, 40, 0.12);
}

.tenant-actions {
  width: min(760px, 100%);
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: clamp(22px, 4vw, 56px);
  margin: 0 auto;
}

.tenant-action-btn {
  width: 100% !important;
  min-height: 82px !important;
  font-size: clamp(30px, 2.6vw, 44px) !important;
  font-weight: 900 !important;
}

@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}
</style>
